// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    export enum UserDataType {
  ApplicationLayout = 1,
  MultiPdfLocalLibraryReports = 2,
}
